/**
 * Shared state for the admin "docked" chat presentation.
 *
 * `<ChatExperience presentation="dock">` flips `open` while the chat is expanded;
 * the host layout reads `open` to reflow its page content (a right inset equal to
 * the `--chat-dock-width` CSS variable) so the chat panel sits *beside* — not
 * *over* — the page. This keeps the user's working context (e.g. the open
 * resource editor) visible while they chat, instead of the full-screen takeover
 * used on the candidate surface.
 *
 * `open` is backed by Nuxt `useState` so it is SSR-safe (a single shared value per
 * request, defaulting closed) and reactive across the disconnected
 * `<ChatExperience>` (leaf) and the layout (root). The panel width is owned by CSS
 * (`--chat-dock-width`, default 440px) so it stays single-sourced.
 */
export function useChatDock() {
  const open = useState<boolean>("chat:dock-open", () => false);

  function close() {
    open.value = false;
  }

  return { open, close };
}
